<template>
	<CollapsedNavigationAccordionMenu
		:to="to"
		:title="title"
		:settings="settings"
		:sections="sections"
		v-if="useIsSidebarCollapsed"
		:titleSuffixComponent="titleSuffixComponent"
		:additionalItemSuffix="additionalItemSuffix"
	>
		<template #activator="{ value }">
			<AnemicButton :class="{ selected: isRouteActive, 'menu-open': value }" class="nav-btn pa-0 width-100" tile>
				<NavigationButton :isSidebarCollapsed="useIsSidebarCollapsed" :item="collapsedModeNavButtonItem" />
			</AnemicButton>
		</template>
	</CollapsedNavigationAccordionMenu>
	<div v-else>
		<Row @click.native="$emit('update:isOpen', !isOpen)" class="flex-align-center accordion-header px-3 py-1 flex-justify-space-between">
			<Row class="flex-align-center">
				<h5 class="accordion-title">{{ title }}</h5>
				<v-icon :class="{ rotate: !isOpen }" class="ml-1 chevron">mdi-chevron-down</v-icon>
				<component v-if="titleSuffixComponent?.component" :is="titleSuffixComponent.component" :class="titleSuffixComponent.class" />
			</Row>
			<template v-if="createNewConfig">
				<AppTooltip :disabled="!createNewConfig.tooltipText" :text="createNewConfig.tooltipText">
					<Col @click.native.stop="createNewConfig.createNew" class="create-new-button flex-centerize">
						<SIcon name="create-new-placement-plus" />
					</Col>
				</AppTooltip>
			</template>
		</Row>
	</div>
</template>
<script>
import { mapGettersShorthand } from '@/store/utils/mappers';
import { useIsSidebarCollapsed } from '@/store/modules/appLayout/getters';
import CreateAndManageService from '../ManageAndCreate/create-and-manage-service';
import CollapsedNavigationAccordionMenu from './CollapsedNavigationAccordionMenu.vue';
import NavigationButton from '@/views/AppLayout/AppNavigation/common/NavigationButton.vue';
export default {
	name: 'NavigationAccordionHeader',
	components: {
		NavigationButton,
		CollapsedNavigationAccordionMenu,
	},
	props: {
		to: { type: Function },
		title: { type: String },
		isOpen: { type: Boolean },
		sections: { type: Array },
		settings: { type: Object },
		createNewConfig: { type: Object },
		titleSuffixComponent: { type: Object },
		additionalItemSuffix: { type: Object },
		collapsedModeNavButtonItem: { type: Object },
	},
	computed: {
		...mapGettersShorthand({ useIsSidebarCollapsed }),
		isRouteActive() {
			return CreateAndManageService.isRouteOrChildOfRoute(this.$route, this.collapsedModeNavButtonItem.routeName);
		},
	},
};
</script>
<style lang="scss" scoped>
.create-new-button {
	height: 14px;
	width: 14px;
	cursor: pointer;
	border-radius: 50%;
	&.active,
	&:hover {
		background: #f2f2f2;
		border: 1px solid var(--border-color);
	}
}
.accordion-title {
	font-size: 11px;
	font-weight: 600;
}
.chevron {
	font-size: 20px;
	color: #7c828d;
	transition: var(--transition-time);
	&.rotate {
		transform: rotate(-180deg);
	}
}
.accordion-header {
	cursor: pointer;
	border-radius: 7px;
	transition: var(--transition-time);
	&:hover {
		background: #f4f5f680;
	}
}
.nav-btn {
	$in-transition-time: 0.1s;
	$out-transition-time: 0.1s;
	height: 36px;
	color: #4d4c52;
	border-radius: 7px;
	text-decoration: none;
	font-weight: normal;
	background: var(--white) !important;
	&:hover {
		background: rgba(128, 128, 128, 0.1) !important;
	}
	&:before {
		position: absolute;
		top: 0;
		left: 0;
		content: '';
		height: 100%;
		width: 100%;
		border-radius: 6px;
		background: rgba(255, 255, 255, 0.2) !important;
		opacity: 0;
	}

	&.selected {
		background: #f4f5f6 !important;
		::v-deep {
			svg,
			path,
			rect,
			line {
				font-weight: 500;
				stroke: #7368d1;
			}
		}
		color: #7368d1;
		font-weight: normal;
		font-weight: 500;
		transition: $in-transition-time;

		&:before {
			opacity: 1;
			transition: $in-transition-time;
		}
	}
	&:hover {
		background: #f4f5f680 !important;
		&:before {
			transition: $in-transition-time;
			opacity: 0.7;
		}
	}
	&:not(:hover),
	:not(.selected):not(:hover) {
		transition: $out-transition-time;

		&:before {
			transition: $out-transition-time;
		}
	}

	&:not(.selected) {
		transition: $out-transition-time;
		::v-deep {
			svg,
			path,
			rect,
			line {
				stroke: #6c7395;
			}
		}
	}

	&.menu-open {
		transition: $in-transition-time;
		background: #e9edf2 !important;
	}
}
</style>
